// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --menu-ink: #eef1ff;
  --menu-muted: rgba(238, 241, 255, 0.72);
  --menu-panel: rgba(12, 16, 30, 0.8);
  --menu-border: rgba(255, 255, 255, 0.08);
  --menu-glow: rgba(89, 232, 255, 0.2);
  --menu-accent: #5ee4ff;
  --menu-accent-2: #ffcc66;
  --menu-shadow: 0 20px 40px -18px rgba(0, 0, 0, 0.6);
}

.app-shell {
  min-height: 100vh;
  background: radial-gradient(800px 500px at 10% 5%, rgba(94, 228, 255, 0.08), transparent 55%),
              radial-gradient(900px 550px at 85% 0%, rgba(255, 204, 102, 0.08), transparent 55%),
              #0a0f1f;
}

.app-shell__content {
  padding: 18px 20px 28px;
}

.app-shell__content--full {
  padding: 0;
}

.app-menu {
  position: sticky;
  top: 0;
  z-index: 2000;
  backdrop-filter: blur(12px);
}

.app-menu__bar {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 14px 20px;
  background: var(--menu-panel);
  border-bottom: 1px solid var(--menu-border);
  box-shadow: var(--menu-shadow);
  font-family: 'Space Grotesk', sans-serif;
}

.app-menu__brand {
  display: flex;
  flex-direction: column;
  gap: 2px;
  cursor: pointer;
}

.app-menu__logo {
  font-weight: 700;
  letter-spacing: -0.02em;
  font-size: 1.2rem;
  color: var(--menu-ink);
}

.app-menu__tag {
  font-size: 0.75rem;
  color: var(--menu-muted);
}

.app-menu__links {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
}

.app-menu__link {
  color: var(--menu-ink);
  padding: 8px 12px;
  border-radius: 999px;
  font-size: 0.92rem;
  text-decoration: none;
  border: 1px solid transparent;
  background: rgba(255, 255, 255, 0.04);
  transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.app-menu__link-btn {
  appearance: none;
  cursor: pointer;
  font: inherit;
}

.app-menu__link:hover {
  transform: translateY(-1px);
  border-color: rgba(94, 228, 255, 0.4);
  background: rgba(94, 228, 255, 0.12);
}

.app-menu__link.is-active {
  border-color: rgba(255, 204, 102, 0.45);
  background: rgba(255, 204, 102, 0.16);
}

.app-menu__dropdown {
  position: relative;
}

.app-menu__dropdown-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.app-menu__caret {
  font-size: 0.75rem;
}

.app-menu__dropdown-panel {
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  min-width: 170px;
  background: rgba(10, 14, 26, 0.98);
  border: 1px solid var(--menu-border);
  border-radius: 14px;
  padding: 8px;
  box-shadow: var(--menu-shadow);
  opacity: 0;
  pointer-events: none;
  transform: translateY(6px);
  transition: all 0.2s ease;
}

.app-menu__dropdown.is-open .app-menu__dropdown-panel {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}

.app-menu__dropdown-item {
  display: block;
  padding: 8px 12px;
  color: var(--menu-ink);
  text-decoration: none;
  border-radius: 10px;
  font-size: 0.9rem;
}

.app-menu__dropdown-item:hover {
  background: rgba(94, 228, 255, 0.12);
}

.app-menu__dropdown-item.is-active {
  background: rgba(255, 204, 102, 0.18);
}

.app-menu__actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.app-menu__user {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid var(--menu-border);
  cursor: pointer;
  transition: all 0.2s ease;
}

.app-menu__user:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
}

.app-menu__avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--menu-accent), var(--menu-accent-2));
  display: grid;
  place-items: center;
  font-weight: 700;
  color: #09111f;
}

.app-menu__user-name {
  font-size: 0.9rem;
  color: var(--menu-ink);
}

.app-menu__user-balance {
  font-size: 0.75rem;
  color: var(--menu-muted);
}

.app-menu__logout {
  padding: 8px 14px;
  border-radius: 999px;
  border: 1px solid rgba(255, 99, 92, 0.4);
  background: rgba(255, 99, 92, 0.12);
  color: #ffd2cc;
  font-size: 0.9rem;
  cursor: pointer;
}

.app-menu__deposit {
  padding: 8px 14px;
  border-radius: 999px;
  border: 1px solid rgba(94, 228, 255, 0.5);
  background: rgba(94, 228, 255, 0.14);
  color: var(--menu-ink);
  font-size: 0.9rem;
  cursor: pointer;
}

.app-menu__hamburger {
  display: none;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--menu-border);
  border-radius: 12px;
  padding: 8px 10px;
  cursor: pointer;
}

.app-menu button:hover {
  transform: none;
  box-shadow: none;
}

.app-menu__hamburger span {
  display: block;
  width: 18px;
  height: 2px;
  background: var(--menu-ink);
  margin: 4px 0;
  border-radius: 999px;
}

.app-menu__backdrop {
  position: fixed;
  inset: 0;
  background: rgba(2, 6, 23, 0.6);
  z-index: 1999;
}

.app-menu__drawer {
  position: fixed;
  top: 0;
  left: 0;
  width: min(78vw, 320px);
  height: 100vh;
  height: 100dvh;
  max-height: 100dvh;
  background: #0b1021;
  border-right: 1px solid var(--menu-border);
  padding: 16px;
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  z-index: 2000;
  box-shadow: var(--menu-shadow);
}

.app-menu__drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.app-menu__close {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--menu-border);
  color: var(--menu-ink);
  border-radius: 10px;
  padding: 6px 10px;
  cursor: pointer;
}

.app-menu__drawer-section {
  display: grid;
  gap: 8px;
}

.app-menu__drawer-title {
  font-size: 0.8rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--menu-muted);
}

.app-menu__drawer-toggle {
  width: 100%;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid var(--menu-border);
  background: rgba(255, 255, 255, 0.04);
  color: var(--menu-ink);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.92rem;
  cursor: pointer;
}

.app-menu__drawer-toggle .app-menu__caret {
  transition: transform 0.2s ease;
}

.app-menu__drawer-toggle[aria-expanded='true'] .app-menu__caret {
  transform: rotate(180deg);
}

.app-menu__drawer-sublist {
  display: grid;
  gap: 8px;
  margin-top: 0;
  padding-left: 8px;
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transform: translateY(-4px);
  transition: max-height 0.22s ease, opacity 0.18s ease, transform 0.18s ease, margin-top 0.18s ease;
}

.app-menu__drawer-sublist.is-open {
  max-height: 260px;
  opacity: 1;
  transform: translateY(0);
  margin-top: 6px;
}

.app-menu__drawer-link {
  padding: 10px 12px;
  border-radius: 12px;
  text-decoration: none;
  color: var(--menu-ink);
  background: rgba(255, 255, 255, 0.04);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.app-menu__drawer-link[type='button'] {
  appearance: none;
  border: none;
  width: 100%;
  cursor: pointer;
  font: inherit;
  text-align: left;
}

.app-menu__drawer-link.is-active {
  background: rgba(94, 228, 255, 0.16);
  border: 1px solid rgba(94, 228, 255, 0.4);
}

.app-menu__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  border-radius: 999px;
  background: rgba(94, 228, 255, 0.2);
  border: 1px solid rgba(94, 228, 255, 0.4);
  color: var(--menu-ink);
  font-size: 0.7rem;
  font-weight: 700;
}

.app-menu__drawer-footer {
  margin-top: auto;
  display: grid;
  gap: 12px;
}

.app-menu__drawer-session-btn {
  width: 100%;
  justify-self: stretch;
  text-align: center;
}

.app-menu__drawer-user {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: 12px;
  border: 1px solid var(--menu-border);
  background: rgba(255, 255, 255, 0.04);
  cursor: pointer;
  transition: all 0.2s ease;
}

.app-menu__drawer-user:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
}

@media (max-width: 980px) {
  .app-menu__links,
  .app-menu__actions {
    display: none;
  }

  .app-menu__hamburger {
    display: inline-block;
  }

  .app-shell__content {
    padding: 14px 14px 24px;
  }

  /* fullBleed pages (chess match, etc.) must never have side padding */
  .app-shell__content--full {
    padding: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/AppMenu.css"],"names":[],"mappings":"AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mCAAmC;EACnC,wCAAwC;EACxC,oCAAoC;EACpC,sBAAsB;EACtB,wBAAwB;EACxB,mDAAmD;AACrD;;AAEA;EACE,iBAAiB;EACjB;;qBAEmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,2CAA2C;EAC3C,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,qCAAqC;EACrC,6EAA6E;EAC7E,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,gBAAgB;EAChB,kCAAkC;EAClC,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,UAAU;EACV,oBAAoB;EACpB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,oCAAoC;EACpC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6EAA6E;EAC7E,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,wCAAwC;EACxC,mCAAmC;EACnC,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yCAAyC;EACzC,oCAAoC;EACpC,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,wDAAwD;EACxD,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,qCAAqC;EACrC,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B,kGAAkG;AACpG;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mCAAmC;EACnC,yCAAyC;EACzC,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,qCAAqC;EACrC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;EACzB;;EAEA,qEAAqE;EACrE;IACE,UAAU;EACZ;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&display=swap');\n\n:root {\n  --menu-ink: #eef1ff;\n  --menu-muted: rgba(238, 241, 255, 0.72);\n  --menu-panel: rgba(12, 16, 30, 0.8);\n  --menu-border: rgba(255, 255, 255, 0.08);\n  --menu-glow: rgba(89, 232, 255, 0.2);\n  --menu-accent: #5ee4ff;\n  --menu-accent-2: #ffcc66;\n  --menu-shadow: 0 20px 40px -18px rgba(0, 0, 0, 0.6);\n}\n\n.app-shell {\n  min-height: 100vh;\n  background: radial-gradient(800px 500px at 10% 5%, rgba(94, 228, 255, 0.08), transparent 55%),\n              radial-gradient(900px 550px at 85% 0%, rgba(255, 204, 102, 0.08), transparent 55%),\n              #0a0f1f;\n}\n\n.app-shell__content {\n  padding: 18px 20px 28px;\n}\n\n.app-shell__content--full {\n  padding: 0;\n}\n\n.app-menu {\n  position: sticky;\n  top: 0;\n  z-index: 2000;\n  backdrop-filter: blur(12px);\n}\n\n.app-menu__bar {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  padding: 14px 20px;\n  background: var(--menu-panel);\n  border-bottom: 1px solid var(--menu-border);\n  box-shadow: var(--menu-shadow);\n  font-family: 'Space Grotesk', sans-serif;\n}\n\n.app-menu__brand {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  cursor: pointer;\n}\n\n.app-menu__logo {\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  font-size: 1.2rem;\n  color: var(--menu-ink);\n}\n\n.app-menu__tag {\n  font-size: 0.75rem;\n  color: var(--menu-muted);\n}\n\n.app-menu__links {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n}\n\n.app-menu__link {\n  color: var(--menu-ink);\n  padding: 8px 12px;\n  border-radius: 999px;\n  font-size: 0.92rem;\n  text-decoration: none;\n  border: 1px solid transparent;\n  background: rgba(255, 255, 255, 0.04);\n  transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.app-menu__link-btn {\n  appearance: none;\n  cursor: pointer;\n  font: inherit;\n}\n\n.app-menu__link:hover {\n  transform: translateY(-1px);\n  border-color: rgba(94, 228, 255, 0.4);\n  background: rgba(94, 228, 255, 0.12);\n}\n\n.app-menu__link.is-active {\n  border-color: rgba(255, 204, 102, 0.45);\n  background: rgba(255, 204, 102, 0.16);\n}\n\n.app-menu__dropdown {\n  position: relative;\n}\n\n.app-menu__dropdown-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.app-menu__caret {\n  font-size: 0.75rem;\n}\n\n.app-menu__dropdown-panel {\n  position: absolute;\n  top: calc(100% + 10px);\n  left: 0;\n  min-width: 170px;\n  background: rgba(10, 14, 26, 0.98);\n  border: 1px solid var(--menu-border);\n  border-radius: 14px;\n  padding: 8px;\n  box-shadow: var(--menu-shadow);\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(6px);\n  transition: all 0.2s ease;\n}\n\n.app-menu__dropdown.is-open .app-menu__dropdown-panel {\n  opacity: 1;\n  pointer-events: auto;\n  transform: translateY(0);\n}\n\n.app-menu__dropdown-item {\n  display: block;\n  padding: 8px 12px;\n  color: var(--menu-ink);\n  text-decoration: none;\n  border-radius: 10px;\n  font-size: 0.9rem;\n}\n\n.app-menu__dropdown-item:hover {\n  background: rgba(94, 228, 255, 0.12);\n}\n\n.app-menu__dropdown-item.is-active {\n  background: rgba(255, 204, 102, 0.18);\n}\n\n.app-menu__actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.app-menu__user {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid var(--menu-border);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.app-menu__user:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.app-menu__avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--menu-accent), var(--menu-accent-2));\n  display: grid;\n  place-items: center;\n  font-weight: 700;\n  color: #09111f;\n}\n\n.app-menu__user-name {\n  font-size: 0.9rem;\n  color: var(--menu-ink);\n}\n\n.app-menu__user-balance {\n  font-size: 0.75rem;\n  color: var(--menu-muted);\n}\n\n.app-menu__logout {\n  padding: 8px 14px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 99, 92, 0.4);\n  background: rgba(255, 99, 92, 0.12);\n  color: #ffd2cc;\n  font-size: 0.9rem;\n  cursor: pointer;\n}\n\n.app-menu__deposit {\n  padding: 8px 14px;\n  border-radius: 999px;\n  border: 1px solid rgba(94, 228, 255, 0.5);\n  background: rgba(94, 228, 255, 0.14);\n  color: var(--menu-ink);\n  font-size: 0.9rem;\n  cursor: pointer;\n}\n\n.app-menu__hamburger {\n  display: none;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid var(--menu-border);\n  border-radius: 12px;\n  padding: 8px 10px;\n  cursor: pointer;\n}\n\n.app-menu button:hover {\n  transform: none;\n  box-shadow: none;\n}\n\n.app-menu__hamburger span {\n  display: block;\n  width: 18px;\n  height: 2px;\n  background: var(--menu-ink);\n  margin: 4px 0;\n  border-radius: 999px;\n}\n\n.app-menu__backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(2, 6, 23, 0.6);\n  z-index: 1999;\n}\n\n.app-menu__drawer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: min(78vw, 320px);\n  height: 100vh;\n  height: 100dvh;\n  max-height: 100dvh;\n  background: #0b1021;\n  border-right: 1px solid var(--menu-border);\n  padding: 16px;\n  padding-bottom: calc(16px + env(safe-area-inset-bottom));\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  z-index: 2000;\n  box-shadow: var(--menu-shadow);\n}\n\n.app-menu__drawer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.app-menu__close {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid var(--menu-border);\n  color: var(--menu-ink);\n  border-radius: 10px;\n  padding: 6px 10px;\n  cursor: pointer;\n}\n\n.app-menu__drawer-section {\n  display: grid;\n  gap: 8px;\n}\n\n.app-menu__drawer-title {\n  font-size: 0.8rem;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--menu-muted);\n}\n\n.app-menu__drawer-toggle {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 12px;\n  border: 1px solid var(--menu-border);\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--menu-ink);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 0.92rem;\n  cursor: pointer;\n}\n\n.app-menu__drawer-toggle .app-menu__caret {\n  transition: transform 0.2s ease;\n}\n\n.app-menu__drawer-toggle[aria-expanded='true'] .app-menu__caret {\n  transform: rotate(180deg);\n}\n\n.app-menu__drawer-sublist {\n  display: grid;\n  gap: 8px;\n  margin-top: 0;\n  padding-left: 8px;\n  max-height: 0;\n  overflow: hidden;\n  opacity: 0;\n  transform: translateY(-4px);\n  transition: max-height 0.22s ease, opacity 0.18s ease, transform 0.18s ease, margin-top 0.18s ease;\n}\n\n.app-menu__drawer-sublist.is-open {\n  max-height: 260px;\n  opacity: 1;\n  transform: translateY(0);\n  margin-top: 6px;\n}\n\n.app-menu__drawer-link {\n  padding: 10px 12px;\n  border-radius: 12px;\n  text-decoration: none;\n  color: var(--menu-ink);\n  background: rgba(255, 255, 255, 0.04);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.app-menu__drawer-link[type='button'] {\n  appearance: none;\n  border: none;\n  width: 100%;\n  cursor: pointer;\n  font: inherit;\n  text-align: left;\n}\n\n.app-menu__drawer-link.is-active {\n  background: rgba(94, 228, 255, 0.16);\n  border: 1px solid rgba(94, 228, 255, 0.4);\n}\n\n.app-menu__badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: rgba(94, 228, 255, 0.2);\n  border: 1px solid rgba(94, 228, 255, 0.4);\n  color: var(--menu-ink);\n  font-size: 0.7rem;\n  font-weight: 700;\n}\n\n.app-menu__drawer-footer {\n  margin-top: auto;\n  display: grid;\n  gap: 12px;\n}\n\n.app-menu__drawer-session-btn {\n  width: 100%;\n  justify-self: stretch;\n  text-align: center;\n}\n\n.app-menu__drawer-user {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n  border-radius: 12px;\n  border: 1px solid var(--menu-border);\n  background: rgba(255, 255, 255, 0.04);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.app-menu__drawer-user:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n@media (max-width: 980px) {\n  .app-menu__links,\n  .app-menu__actions {\n    display: none;\n  }\n\n  .app-menu__hamburger {\n    display: inline-block;\n  }\n\n  .app-shell__content {\n    padding: 14px 14px 24px;\n  }\n\n  /* fullBleed pages (chess match, etc.) must never have side padding */\n  .app-shell__content--full {\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
